"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInWithProvidersModal = void 0;
const Dialog_1 = require("root/src/client/v2/common/components/modal/Dialog");
const SignInWithProviderButtons_1 = require("root/src/client/v2/auth/components/SignInWithProviderButtons");
const ModalTitle_1 = require("root/src/client/v2/common/components/modal/ModalTitle");
function SignInWithProvidersModal() {
    return (<Dialog_1.Dialog className="sm:w-[500px]">
			<ModalTitle_1.ModalTitle>Connect Channels</ModalTitle_1.ModalTitle>
			<SignInWithProviderButtons_1.SignInWithProviderButtons isLinking/>
		</Dialog_1.Dialog>);
}
exports.SignInWithProvidersModal = SignInWithProvidersModal;
